import CookieConsentService from '@modules/modules/CookieConsent/services/CookieConsentService';
import useTracking from '@modules/hooks/tracking';
import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';
import { useDialogStore } from '@ariakit/react';
import cookieConsentService from '@modules/modules/CookieConsent/services/CookieConsentService';

const CookieConsentContext = createContext();

const useCookieConsent = () => useContext(CookieConsentContext);

const CookieConsentProvider = ({
  hideOverlay = false,
  finalFocusRef,
  children,
  service,
}) => {
  if (!service) {
    service = new cookieConsentService();
  }

  const [open, setOpen] = useState(false);
  const dialog = useDialogStore({ open, setOpen });
  const [services, setServices] = useState([]);
  const track = useTracking();
  const [dataService, setDataService] = useState(null);
  const [categories, setCategories] = useState([]);

  useLayoutEffect(() => {
    async function fetchData() {
      const data = await service.initialise();
      setServices(service.getAccepted());
      setDataService(service);
      setCategories(data);
      service.setDialog(dialog);
      return service.reRequestConsent();
    }

    async function modalTrigger() {
      const reRequestConsent = await fetchData();
      const doNotTrack = navigator?.doNotTrack === true;

      if (!doNotTrack && !hideOverlay && reRequestConsent) {
        dialog.show();
      }
    }

    modalTrigger();
  }, []);

  const onAccept = items => {
    if (window.ppms) {
      if (!items.length) {
        // reject all
        window.ppms.cm.api('trackRejectAllClick');
      } else {
        window.ppms.cm.api('trackSaveChoicesClick');
      }
    }

    dataService.updateAll(items);
    setCategories(dataService.getGroups());
    track({
      type: 'cookie-consent',
      services: dataService.saved,
      event: 'partial',
      version: dataService.getVersion(),
    });
    dialog.hide();
    dataService.persist();
    setServices(dataService.getSaved());
    dataService.execDialogCloseCallback();
  };

  const onAcceptAll = () => {
    if (window.ppms) {
      window.ppms.cm.api('trackAgreeToAllClick');
    }

    dataService.acceptAll();
    setCategories(dataService.getGroups());
    track({
      type: 'cookie-consent',
      title: document.title,
      url: document.location.href,
      services: dataService.saved,
      event: 'all',
      version: dataService.getVersion(),
    });

    dialog.hide();
    dataService.persist();
    setServices(dataService.getSaved());
    dataService.execDialogCloseCallback();
  };

  return (
    <CookieConsentContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        finalFocusRef,
        services,
        dialog,
        dataService,
        hideOverlay,
        categories,
        onAccept,
        onAcceptAll,
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};

export default useCookieConsent;

export { CookieConsentContext, CookieConsentProvider };
